import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { SignInForm } from '../../components/user_management/signin-form';
import { useAuth } from '../../contexts/authentication.context';
import authService from '../../services/auth.service';
import config from '../../utils/config';
import './user_management.css';

export function SignInTempAccess() {
	const location = useLocation();
	const navigate = useNavigate();
	const { setAuthenticated } = useAuth();
	useEffect(() => {
		const search = new URLSearchParams(location.search);
		(async () => {
			authService.logout();
			if (search.get('tat')) {
				const { token, profile } = await authService.loginCompanyTempAccess(search.get('tat'));
				setAuthenticated(true, token, profile);
				navigate('/dashboard/jobs');
				return;
			}
			navigate('/signin');
		})();
	}, [setAuthenticated, history, location]);

	return (
		<div className="mx-auto form-container justify-content-center d-flex flex-column align-items-center py-3">
			<p>Please wait....</p>
		</div>
	);
}
